export default function Spinner() {
  return (
    <div className="flex justify-center items-center p-8">
      <div className="w-12 h-12 border-4 border-maroon border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
